// Base interface for PDF documents - minimal interface for new/blank documents

export type NewDocument = {
  page_count: number
  readonly doc_pointer: number
  readonly pdfium: any
  save(): AsyncGenerator<Blob>
  close(): Promise<void>
}
